import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ErrorIcon from "@mui/icons-material/Error";
import { deleteExistingCategory } from "../../../../Redux/ClientSupportManagement/Action";
import { useDispatch } from "react-redux";

export default function DeleteCategoryConfirmPopUp({
  categoryId,
  setOpen,
  isFromUpdatePopUp = false,
  closeUpdatePopUp,
  categoryType,
}) {
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen("");
  };

  const deleteCategory = () => {
    const type = !isFromUpdatePopUp ? "CATEGORY" : categoryType;
    dispatch(deleteExistingCategory({ categoryId, categoryType: type }));
    setOpen("");
    if (isFromUpdatePopUp) {
      closeUpdatePopUp(false);
    }
  };

  return (
    <Dialog open={categoryId} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">
        Delete Category Confirmation
        <span>
          <ErrorIcon sx={{ color: "red", mx: "1px", my: "1px" }} />
        </span>
      </DialogTitle>
      <DialogContent>
        Oops! Are you sure about deleting this category?
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-around",
          mx: "50px",
          marginBottom: "5px",
        }}
      >
        <Button variant="contained" size="small" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" size="small" onClick={deleteCategory}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
